export const API_BASE = "https://jabuzwane.vercel.app/api";

export function makeCalendarInviteUrl(bookingId, token) {
	const url = new URL(`${API_BASE}/notify-booking`);
	url.searchParams.set("calendarInvite", "1");
	url.searchParams.set("bookingId", bookingId);
	url.searchParams.set("token", token);
	return url.toString();
}

export async function createZoomMeeting(bookingId, token) {
	for (let attempt = 0; attempt < 8; attempt += 1) {
		const response = await fetch(`${API_BASE}/notify-booking`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ zoomAction: "ensure", bookingId, token }),
		});
		const data = await response.json();
		if (response.status === 202) {
			await new Promise((resolve) => setTimeout(resolve, 1000));
			continue;
		}
		if (!response.ok) throw new Error(data.message || "Could not set up the Zoom meeting.");
		return data.meetingUrl || "";
	}
	throw new Error("Zoom is still preparing the meeting. Please check again shortly.");
}
